<template>
  <div>
    <modals-container name="modal1" />
    <v-dialog/>
    <div class="class_add_top">
      <a onclick="history.go(-1)" class="back">返回</a>
    </div>
    <div style="padding: 0 10px;">
      <div class="highlight_title">
        {{form.name}} - 学习情况
      </div>
      <!--右侧内容-->
      <div class="gj_top_class" style="background: none;">
        <a @click="showBox" class="btn" style="background: #ff3633;">机构积分再计算</a>
        <a @click="uploadSheets" class="btn" style="background: #ff3633;">上传学习成绩</a>
        <span><a :href="downloadLink">下载导入模板</a></span>
      </div>
      <div class="gj_list" style="min-height: 600px;">
        <h5 class="none_ts" v-if="lists.length == 0">
          <img src="@/assets/images/none_data.jpg" alt="">
          <h4>暂无报名人员学习情况</h4>
        </h5>
        <el-table v-if="lists && lists.length > 0"
                  :data="lists" class="tb-edit" ref="enrollcheckTable" stripe border highlight-current-row @row-click="handleCurrentChange"
                  style="width: 100%">
          <el-table-column
            label="姓名"
            width="180" prop="memberName">
          </el-table-column>
          <el-table-column label="是否通过">
            <template slot-scope="{row,$index}">
              <el-radio v-model="row.pass" label="0">未通过</el-radio>
              <el-radio v-model="row.pass" label="1">已通过</el-radio>
              <span v-if="row.pass == '0'">未通过</span>
              <span v-if="row.pass == '1'">已通过</span>
            </template>
          </el-table-column>
          <el-table-column label="分数">
            <template slot-scope="{row,$index}">
              <el-input size="small" v-model="row.grade" placeholder="请输入分数"></el-input>
              <span>{{row.grade}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="250">
            <template slot-scope="{row, $index}">
              <el-button size="mini" @click.stop="$projCommon.openDialog($modal, modal1, row, vmodel)" v-if="row.id == currentId">保存</el-button>
              <el-button size="mini" v-if="row.id !== currentId" disabled>保存</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="onsite_list_bottom mtf30">
        <div v-if="cntData > 0">共<b>{{cntData}}</b>条报名信息</div>
        <div v-if="cntData > 0">
          <paginate :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text>
          </paginate>
        </div>
      </div>
      <!--/右侧内容-->
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
  import api from '@/api/index'
  import config from '@/config/index'
  import Vue from 'vue'
  import Paginate from 'vuejs-paginate'
  import ModalBox from '@/components/common/modal/index.vue'
  import rangeManip from '@/components/byl/rangeManip/onlyDepts.vue'
  import utils from '@/utils'
  export default {
    components: { Paginate },
    mounted () {
      this.getName(this.$route.params.id).then((r) => {
        this.form = r
        let businessId = this.form.businessId
        this.getModel(this.form.businessId)
      })
    },
    data () {
      return {
        vmodel: this,
        modal1: {
          title: '编辑',
          text: '确认保存吗?',
          yes (model, scope) {
            scope.save(model)
          }
        },
        currentId: '',
        downloadLink: config.upload_sheets,
        filters: {
          pageNo: 1,
          pageSize: 12
        },
        form: {},
        lists: [],
        cntData: 0,
        pages: 0,
        prefix: this.$route.meta.prefix || ''
      };
    },
    computed: {
    },
    methods: {
      clickCallback (pageNum) {
        this.filters.pageNo = pageNum
        this.getModel(this.form.businessId)
      },
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: o.title,
          text: o.text,
          buttons: [
            {
              title: '确认',
              default: true,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      getModel (id) {
        var that = this
        api.post(config.courseApiPath, '/course/learn/course/logs', { courseId: id, pageNo: this.filters.pageNo, pageSize: this.filters.pageSize }, function (r) { // 正常
          if (r.data) {
            that.lists = r.data
            that.cntData = r.cntData // 总数
            that.pages = Math.ceil(r.cntData / that.filters.pageSize) // 页数
          }
        })
      },
      getName (id) {
        return new Promise((resolve, reject) => {
          api.get(config.enrollApiPath, '/signupinfo/get', { id: id }, function (r) { // 正常
            resolve(r.data)
          })
        })
      },
      uploadSheets () {
        var that = this
        this.confirmBox({
          title: '上传学习成绩',
          text: '<input id="uploadSheets" type="file">',
          yes: function () {
            var file = document.getElementById('uploadSheets').files;
            if (file.length) {
              var isExcel = /\.(?:xls|xlsx)$/i.test(file[0].name);
              if (isExcel) {
                var o = {}
                o.file = file[0]
                var fd = new FormData()
                for (var key in o) {
                  fd.append(key, o[key])
                }
                api.post(config.courseApiPath, '/course/learn/importGrade', fd, function (r) { // 正常
                  that.$toasted.show(r.data, {duration: 10000})
                  setTimeout(function () {
                    that.getModel(that.form.businessId)
                  }, 0)
                  that.$modal.hide('dialog')
                })
              } else {
                that.$toasted.show('只允许上传.xsl,.xslx格式的文件')
              }
            } else {
              that.$toasted.show('请选择文件')
            }
          }
        })
      },
      showBox () {
        var that = this
        this.$modal.show(ModalBox, {
          opts: {
            title: '机构积分再计算',
            styles: {
              width: '660',
              height: String(0.8242 * window.screen.availHeight)
            },
            currentComponent: {
              name: 'range',
              template: rangeManip,
              outputsKey: 'outputs' // 该组件对外输出数据时，定义的key值
            },
            yes (val) { // 点击确认后要做的事情
              let ids = (val.form.type == '2') ? utils.grabVal(val.people, 'id') : null
              api.post(config.enrollApiPath, '/depPoint/updateDepPoint', { depIdList: ids }, function (r) { // 正常
                that.$toasted.show('部门积分已重新计算')
                that.getModel(that.form.businessId)
                that.$modal.hide('dialog')
              })
            }
          }
        })
      },
      handleCurrentChange(row, event, column) {
        this.currentId = row.id
      },
      save (model) {
        var that = this
        api.post(config.courseApiPath, '/course/learn/change/score', { id: model.id, pass: model.pass, grade: model.grade }, function (r) { // 正常
          that.$toasted.show('修改成功')
          that.currentId = ''
          that.$refs.enrollcheckTable.setCurrentRow() // 取消选中
          that.$modal.hide('dialog')
        })
      }
    }
  }
</script>

<style scoped>
  .xo-table-btn {
    padding: 5px;
    background-color: #ff3633;
    color: white;
    border-radius: 5px;
    cursor: pointer;
  }
  .highlight_title {
    height: 60px;
    line-height: 60px;
    background: #fcca75;
    text-align: center;
    font-weight: normal;
    margin-top: 10px;
    color: #fff;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/page/byl/org/enroll/check.vue